import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import release from '@/components/release'
import register from '@/components/login/register'
import login from '@/components/login/login'
import detail from '@/components/detail'
import infor from '@/components/infor'
import supplier from '@/components/supplier'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/release',
      name: 'release',
      component: release
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    },
    {
      path: '/infor',
      name: 'infor',
      component: infor
    },
    {
      path: '/supplier',
      name: 'supplier',
      component: supplier
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js